import React from 'react';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About Me</h2>
        <div className="about-content">
          <div className="about-img">
            <img src="/user-pic.jpg" alt="Khalil Ahmad" />
          </div>
          <div className="about-text">
            <h2>Aspiring DevOps Engineer & Cloud Enthusiast</h2>
            <p>I am a BSCS graduate having a deep interest in DevOps & Cloud. Practical experience using Linux, Git/GitHub, Docker, Kubernetes, AWS Cloud Platform, Jenkins, and GitHub Actions.</p>
            <p>I am knowledgeable about CI/CD pipelines and basic cloud deployments. Currently looking for an internship or junior DevOps position to utilize my skills and learn more about the practical aspect of industry.</p>

            <div className="about-stats">
              <div className="stat">
                <div className="stat-number">6+</div>
                <div className="stat-text">Major Projects</div>
              </div>
              <div className="stat">
                <div className="stat-number">99%</div>
                <div className="stat-text">Discipline</div>
              </div>
              <div className="stat">
                <div className="stat-number">99%</div>
                <div className="stat-text">Motivated</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
